export default function Footer() {
  const footerLinks = [
    {
      title: '科普分类',
      links: [
        { label: '奶水分泌原理', to: '/category/milk-secretion' },
        { label: '哺乳姿势动画', to: '/category/feeding-positions' },
        { label: '追奶技巧', to: '/category/milk-boosting' },
        { label: '断奶过渡', to: '/category/weaning' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌故事', to: '/about' },
        { label: '用户口碑', to: '/about#reputation' },
        { label: '联系我们', to: '/about#contact' },
      ],
    },
    {
      title: '热门文章',
      links: [
        { label: '正确含接姿势动画教程', to: '/article/correct-latch-position' },
        { label: '母乳分泌的全过程动画演示', to: '/article/milk-secretion-process' },
        { label: 'Power Pumping强力吸奶法', to: '/article/power-pumping-technique' },
        { label: '温和断奶全攻略', to: '/article/gentle-weaning-guide' },
      ],
    },
  ];

  return (
    <footer className="bg-accent-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center bg-background-50 rounded-full">
                <i className="ri-drop-fill text-accent-500 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50">奶水动画</span>
            </Link>
            <p className="text-sm text-background-50/80 leading-relaxed">
              专为新手妈妈打造的母乳哺育可视化科普平台，让每一位妈妈轻松掌握科学哺乳知识。
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-medium text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-background-50/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/60">
            &copy; {new Date().getFullYear()} 奶水动画 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/60 hover:text-background-50 transition-colors text-sm" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-50/60 hover:text-background-50 transition-colors text-sm" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}